import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";

export default class Accolades extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Accolades._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	fetchData = async (state) => {
		this.state.filter = {};
		if (this.props.self_only) {
			this.state.filter.self_only = true
		}
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = !this.props.self_only ? [{
			Header: "User",
			accessor: "user_name",
		}] : [];

		columns.push(
			{
				Header: "Accolade Name",
				accessor: "accolade_name",
			},
			{
				Header: "Date Accomplished",
				id: 'created',
				accessor: obj => moment(obj.created).format('MM/DD/YYYY h:mm A'),
			},
		)
		return (
			<div className={'box-body'}>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key + this.props.self_only}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
